/**

 * JavaScript functions for SIW_IPP_TAB.HTS - v1.0 Chris Salt
 * 11/03/2014
 * 24/09/2014 - Remove function from global namespace
 */

import $ from 'jquery';

$(document).ready(function () {

    var displayVal,
        data = {};

    try {
        data = $.parseJSON($('#siw_ipp_tab_data').text());
    } catch (e) {}

    if ($.isEmptyObject(data) === false) {

        displayVal = function (value, fieldName) {
            if ($.type(value) !== 'undefined') {
                if (value.length > 0) {
                    $('#' + fieldName).find('#' + fieldName + 'Val').text(value).parent().removeClass('hidden');
                }
            }
        };

        if (data.json.hasOwnProperty('ipu')) {
            displayVal(data.json.ipu.ipu_code, 'tabIPURef');
        }

        if (data.json.hasOwnProperty('ipr')) {
            displayVal(data.json.ipr.ipr_bref, 'tabAppRef');
        }

        if (data.json.hasOwnProperty('mua')) {
            displayVal(data.json.mua.mua_alis, 'muaAlias');
        }

        if (data.json.hasOwnProperty('ipp')) {
            //displayVal(data.json.ipp.fac_name, 'tabFaculty');
            //displayVal(data.json.ipp.dpt_name, 'tabSchool');
            displayVal(data.json.ipp.ipp_titl, 'tabProg');
        }

        if ($('#ipuSurname').val().length === 0) {
            $('#loggedInUser').hide();
        }

        if (data.json.hasOwnProperty('genericHelp')) {
            $('#genericHelpTitle').html(data.json.genericHelp.title);
            $('#genericHelpContent').html(data.json.genericHelp.content);
            $('#navBarHelp').show();
        }

        $('#navBarInfoButton').popover({
            content: $('#ippTabWidget').html()
        });
    }
});



// WEBPACK FOOTER //
// ./ku/js/siw_ipp_tab.js